import '../css/PostList.css';
import { useState } from "react";
import { Flex } from 'antd';
import { useQuery } from "@apollo/client";
import { GET_POST_LIST } from "../queries";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import parsePosts from '../utils/parsePosts';
import News from './Cards/News';
import useIsMobile from '../utils/isMobile'
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl"

const mediaDir = (lang) => {
	let dir = ''
	
	if (lang === 'es') {
		dir = 'medios'
	} else if (lang === 'en') {
		dir = 'media'
	} else if (lang === 'pt') {
		dir = 'midia'
	}
	
	return dir
}

const PostList = ({ page, section, numPosts, categoryName, lang }) => {
	const isMobile = useIsMobile();
	const slug = `${page}-${section}-${lang}`;
	const [sectionData, setSectionData] = useState(() => {
		const cachedData = getFromLocalStorage(page);
		return cachedData?.sections?.[slug] || null;
	});

	const { loading, error } = useQuery(GET_POST_LIST, {
		variables: { slug, categoryName, numPosts: numPosts, lang: lang === 'pt' ? 'pt-br' : lang },
		skip: !!sectionData,
		onCompleted: (fetchedData) => {
			const postData = {
				titulo: fetchedData.sectionsBy?.postlist?.tituloPl,
				posts: parsePosts(fetchedData?.posts),
			}
			const dataToLocal = {
				...sectionData,
				sections: {
					[slug]: postData,
				},
			};
			saveToLocalStorage(page, dataToLocal);
			setSectionData(postData);
		},
	});

	return (
		<>
			{
				sectionData && (
					<Flex className="PostList">
						<Flex className="PostList-title">
							<Flex>
								<h2
									className="h4-headline-500"
									dangerouslySetInnerHTML={{ __html: sectionData?.titulo }}
								/>
							</Flex>
						</Flex>
						<div className="grid-container">
							{sectionData?.posts.map((post, index) => (
								<News key={index} title={post.title} image={setImageAbsoluteUrl(post.mediaItemUrl)} description={post.content} slug={`/${lang}/${categoryName}/${post.slug}`} type={categoryName} isMobile={isMobile} />
							))}
						</div>
					</Flex>
				)
			}
		</>
	);
}

export default PostList;